import { render, staticRenderFns } from "./post-add-or-update.vue?vue&type=template&id=c6bba4a8&scoped=true"
import script from "./post-add-or-update.vue?vue&type=script&lang=js"
export * from "./post-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./post-add-or-update.vue?vue&type=style&index=0&id=c6bba4a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6bba4a8",
  null
  
)

export default component.exports